import React, { useState } from 'react'
import { IconContext } from 'react-icons'
import { IconTooltip as Tooltip } from '../Tooltip'
import { FaCompressArrowsAlt, FaExpandArrowsAlt } from 'react-icons/fa'

const ExpandButton = ({ name, isExpanded, setIsExpanded }) => {
    return (
        <>
            <div
                className={`panelHeaderIconDiv`}
                data-tip={`${
                    isExpanded ? `Collapse` : `Expand to Full Screen`
                }`}
                data-for={`${name}-expanded-${isExpanded}`}
                onClick={() => setIsExpanded(current => !current)}
            >
                <IconContext.Provider
                    value={{
                        className: `panelHeaderIcon`,
                    }}
                >
                    {isExpanded ? (
                        <FaCompressArrowsAlt />
                    ) : (
                        <FaExpandArrowsAlt />
                    )}
                </IconContext.Provider>
                <Tooltip id={`${name}-expanded-${isExpanded}`} />
            </div>
        </>
    )
}

export default ExpandButton
